import * as React from 'react'
import { FC, useMemo } from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { ILeadDetail } from '@user/store/lead/typings'
import { IOpportunityDetail } from '@user/store/opportunity/typings'
import { LEAD_STATUSES } from '../Leads/LeadCard/typings'
import { OPPORTUNITY_STATUSES } from '../Opportunities/OpportunityCard/typings'
import { useCheckPermissions } from '@user/store/authorization/permissions'
import { ServiceDialog } from './ServiceDialog'

interface Props {
  detail: ILeadDetail | IOpportunityDetail
  entityStatus: LEAD_STATUSES | OPPORTUNITY_STATUSES
  entityType: ENTITY_TYPES
  isOpen: boolean
  onClose: () => void
}

export const ServiceDialogEntityDetailWrapper: FC<Props> = (props) => {
  const { detail, entityStatus, entityType, isOpen, onClose } = props

  const [canUpdateLeads, canUpdateOpportunities] = useCheckPermissions(
    'leads_update',
    'opportunities_update',
  )

  const isLeadDetail = useMemo(() => {
    return entityType == ENTITY_TYPES.Lead
  }, [entityType])

  const canUpdate = useMemo(() => {
    return isLeadDetail ? canUpdateLeads : canUpdateOpportunities
  }, [canUpdateLeads, canUpdateOpportunities, isLeadDetail])

  const isClosedOpp = useMemo(() => {
    return (
      entityStatus == OPPORTUNITY_STATUSES.Lost ||
      entityStatus == OPPORTUNITY_STATUSES.Won
    )
  }, [entityStatus])

  const isDisqualifiedLead = useMemo(() => {
    return entityStatus == LEAD_STATUSES.Disqualified
  }, [entityStatus])

  const deleteServiceWarningMessage = useMemo(() => {
    return isLeadDetail
      ? ''
      : 'Opportunities require at least one product or service'
  }, [isLeadDetail])

  const minimumServicesCount = useMemo(() => {
    return isLeadDetail ? 0 : 1
  }, [isLeadDetail])

  return (
    <ServiceDialog
      address={detail.serviceContact.street1}
      branchId={detail.branchId}
      deleteServiceWarningMessage={deleteServiceWarningMessage}
      entityId={detail.id}
      entityType={entityType}
      minimumServicesCount={minimumServicesCount}
      open={isOpen}
      onClose={onClose}
      openAddServiceDrawerOnMount={false}
      readOnly={!canUpdate || isClosedOpp || isDisqualifiedLead}
      locationSource="existing"
      referralDiscountId={detail.referralSummary?.referralDiscountId}
    />
  )
}
ServiceDialogEntityDetailWrapper.displayName =
  'ServiceDialogEntityDetailWrapper'
